<template>
  <el-dialog class="auditCheck"
             :visible.sync="auditVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="1300px"
             title="考勤审核">
    <el-alert :title="remark"
              type="warning"
              :closable="false">
    </el-alert>
    <div class="auditCheckTable">
      <el-scrollbar style="height:100%">
        <el-table border
                  :data="tableData"
                  highlight-current-row
                  height='400'>
          <el-table-column label="姓名"
                           align="center"
                           property="name">
          </el-table-column>
          <el-table-column label="工号"
                           property="job_no"
                           align="center">
          </el-table-column>
          <el-table-column label="部门"
                           property="depart"
                           align="center">
          </el-table-column>
          <el-table-column label="日期"
                           property="sign_date"
                           align="center">
          </el-table-column>
          <el-table-column label="星期"
                           property="week"
                           align="center">
          </el-table-column>
          <el-table-column label="上班时间"
                           align="center">
            <template slot-scope="scope">
              <div :style="scope.row.sign_in?'':'color:red'">
                {{scope.row.sign_in?scope.row.sign_in:'--'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="下班时间"
                           align="center">
            <template slot-scope="scope">
              <div :style="scope.row.sign_out?'':'color:red'">
                {{scope.row.sign_out?scope.row.sign_out:'--'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           align="center">
            <template slot-scope="scope">
              <div :style="scope.row.sign_in && scope.row.sign_out?'':'color:red'">
                {{scope.row.sign_in && scope.row.sign_out?'正常':'异常'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="上班确认"
                           align="center">
            <template slot-scope="scope">
              <div :style="scope.row.resign_in?'':'color:red'">
                {{scope.row.resign_in?scope.row.resign_in:'--'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="下班确认"
                           align="center">
            <template slot-scope="scope">
              <div :style="scope.row.resign_out?'':'color:red'">
                {{scope.row.resign_out?scope.row.resign_out:'--'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="备注"
                           align="center">
            <template slot-scope="scope">
              <div :style="scope.row.resign_remark?'':'color:red'">
                {{scope.row.resign_remark?scope.row.resign_remark:'--'}}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 type="primary"
                 @click="auditAttendance">审核</el-button>
      <el-button size="small"
                 @click="auditVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
export default {
  data () {
    return {
      tableData: [],
      remark: ""
    }
  },
  methods: {
    closeDialog () {
      this.tableData = []
      this.$emit('update:auditVisible', false)
    },
    pendingAttendance () {
      oaApi.pendingAttendance({}, 'get').then(res => {
        if (res) {
          this.tableData = res.data
          this.remark = res.ext.remark
        }
      })
    },
    auditAttendance () {
      let idlist = []
      for (let i = 0; i < this.tableData.length; i++) {
        idlist.push(this.tableData[i].id)
      }
      oaApi.auditAttendance({ idlist: idlist }, 'post').then(res => {
        if (res) {
          this.$message.success('审核成功');
          this.$store.dispatch("getUserInfo");
          this.closeDialog()
        }
      })
    }
  },
  watch: {
    auditVisible: {
      handler (newValue) {
        this.pendingAttendance()
      },
      deep: true,
      immediate: false
    }
  },
  props: {
    auditVisible: 'Boolean'
  }
}
</script>
<style lang="scss">
.auditCheck {
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }
    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
    .el-dialog__body {
        padding: 10px 20px;
    }
    .auditCheckTable {
        margin-top: 10px;
        height: 100%;
        .redText {
            color: red;
        }
    }
}
</style>